// extracted by mini-css-extract-plugin
module.exports = {"accent":"styles_accent__1Q0ei"};